export const FINANCIAL_KPIS = {
  totalRevenueMonth: 2847500,
  revenueMonthLabel: 'June 2026',
  outstandingReceivables: 412800,
  receivablesAging: {
    current: 185400,
    days31to60: 142200,
    days61plus: 85200,
  },
  invoicesPaid: 47,
  invoicesPending: 12,
  invoicePaidAmount: 2434700,
  invoicePendingAmount: 412800,
  avgProfitabilityPerAsset: 18.4,
  fleetAssetCount: 38,
};

export const TRIP_EXPENSES = [
  {
    tripId: 'TRP-24011',
    clientName: 'Emirates National Oil Co.',
    baseFreight: 18500,
    fuelExpense: 4200,
    tollsSalik: 875,
    driverAllowance: 650,
  },
  {
    tripId: 'TRP-24012',
    clientName: 'ADNOC Distribution',
    baseFreight: 22400,
    fuelExpense: 5100,
    tollsSalik: 1120,
    driverAllowance: 720,
  },
  {
    tripId: 'TRP-24013',
    clientName: 'Gulf Petrochemical Industries',
    baseFreight: 15800,
    fuelExpense: 3650,
    tollsSalik: 640,
    driverAllowance: 580,
  },
  {
    tripId: 'TRP-24014',
    clientName: 'Dubai Petroleum Corp.',
    baseFreight: 19200,
    fuelExpense: 4480,
    tollsSalik: 980,
    driverAllowance: 680,
  },
  {
    tripId: 'TRP-24015',
    clientName: 'Emirates Food Industries LLC',
    baseFreight: 12600,
    fuelExpense: 2900,
    tollsSalik: 520,
    driverAllowance: 540,
  },
  {
    tripId: 'TRP-24016',
    clientName: 'Al Khaleej Sugar Refinery',
    baseFreight: 28900,
    fuelExpense: 6800,
    tollsSalik: 1450,
    driverAllowance: 850,
  },
  {
    tripId: 'TRP-24017',
    clientName: 'OGTS Chemical Partners',
    baseFreight: 21400,
    fuelExpense: 4950,
    tollsSalik: 1050,
    driverAllowance: 700,
  },
  {
    tripId: 'TRP-24018',
    clientName: 'Maritime Beverage Logistics',
    baseFreight: 9800,
    fuelExpense: 2280,
    tollsSalik: 410,
    driverAllowance: 480,
  },
  {
    tripId: 'TRP-24019',
    clientName: 'Gulf Agro Trading FZE',
    baseFreight: 17200,
    fuelExpense: 4020,
    tollsSalik: 890,
    driverAllowance: 620,
  },
  {
    tripId: 'TRP-24020',
    clientName: 'Ruwais Depot Holdings',
    baseFreight: 25600,
    fuelExpense: 5980,
    tollsSalik: 1280,
    driverAllowance: 780,
  },
];

export function computeTripMargin(trip) {
  const totalCost = trip.fuelExpense + trip.tollsSalik + trip.driverAllowance;
  const netProfit = trip.baseFreight - totalCost;
  const netMarginPct = trip.baseFreight > 0 ? (netProfit / trip.baseFreight) * 100 : 0;
  return {
    totalCost,
    netProfit,
    netMarginPct: Math.round(netMarginPct * 10) / 10,
  };
}

export function enrichTripExpenses(trips = TRIP_EXPENSES) {
  return trips.map((trip) => ({
    ...trip,
    ...computeTripMargin(trip),
  }));
}

export function computeTripTableTotals(trips = TRIP_EXPENSES) {
  const enriched = enrichTripExpenses(trips);
  const totals = enriched.reduce(
    (acc, t) => ({
      baseFreight: acc.baseFreight + t.baseFreight,
      fuelExpense: acc.fuelExpense + t.fuelExpense,
      tollsSalik: acc.tollsSalik + t.tollsSalik,
      driverAllowance: acc.driverAllowance + t.driverAllowance,
      netProfit: acc.netProfit + t.netProfit,
    }),
    { baseFreight: 0, fuelExpense: 0, tollsSalik: 0, driverAllowance: 0, netProfit: 0 },
  );
  totals.netMarginPct =
    totals.baseFreight > 0
      ? Math.round((totals.netProfit / totals.baseFreight) * 1000) / 10
      : 0;
  return totals;
}

export function marginTone(pct) {
  if (pct >= 20) return 'text-emerald-700';
  if (pct >= 12) return 'text-logi-accent';
  if (pct >= 8) return 'text-amber-700';
  return 'text-red-700';
}
